import styled from 'styled-components';

export const Container = styled.div`
    height: auto;
    padding: 2rem;
`;